import { gql } from '@apollo/client';

export const GET_LIST_AD_INTEGRATION_ADVANCE_FILTER = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetAdIntegrationList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on AdIntegrations {
        data {
          id
          ad_id
          ad {
            ... on Ad {
              id
              name
              start_date
              end_date
            }
          }
          user_socmed_id
          type
          approved_by_id
          approved_by {
            ... on User {
              id
              name
              email
            }
          }
          created_by_id
          created_by {
            ... on User {
              id
              name
              email
            }
          }
          created_at
          deleted_at
        }
      }
    }
  }
`;

export const GET_LIST_AD_INTEGRATION = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetAdIntegrationList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on AdIntegrations {
        data {
          id
          ad_id
          user_socmed_id
          user_socmed {
            ... on SocmedAccount {
              id
              team_id
              type
              username
              url
              account_token
              active_status
              ad_account_id
            }
          }
          type
          ad {
            ... on Ad {
              id
              ad_set_id
              ad_set {
                ... on AdSet {
                  campaign_id
                  team_id
                  name
                  start_date
                  end_date
                  budget
                  created_at
                  updated_at
                  deleted_at
                  campaign {
                    ... on Campaign {
                      name
                    }
                  }
                }
              }
              team_id
              team {
                ... on Team {
                  id
                  name
                  partner
                  limit
                  start_date
                  end_date
                  created_at
                  updated_at
                  deleted_at
                }
              }
              name
              start_date
              end_date
              budget
              headline
              offer
              content
              created_at
              updated_at
              deleted_at
            }
          }
          socmed_campaign_id
          socmed_ad_id
          socmed_adset_id
          approved_by_id
          approved_by {
            ... on User {
              id
              name
              email
            }
          }
          approval_status
          approval_note
          rejection_note
          created_by_id
          created_by {
            ... on User {
              id
              name
              email
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                  name
                  object_name
                  bucket_name
                }
              }
            }
          }
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;

export const GET_LIST_AD_INTEGRATION_WITHOUT_SOCMED = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetAdIntegrationList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on AdIntegrations {
        data {
          id
          ad_id
          user_socmed_id
          user_socmed {
            ... on SocmedAccount {
              id
              team_id
              type
              username
              url
              account_token
              active_status
            }
          }
          type
          ad {
            ... on Ad {
              id
              ad_set_id
              ad_set {
                ... on AdSet {
                  campaign_id
                  team_id
                  name
                  start_date
                  end_date
                  budget
                  created_at
                  updated_at
                  deleted_at
                }
              }
              team_id
              team {
                ... on Team {
                  id
                  name
                  partner
                  limit
                  start_date
                  end_date
                  created_at
                  updated_at
                  deleted_at
                }
              }
              name
              start_date
              end_date
              budget
              headline
              offer
              content
              created_at
              updated_at
              deleted_at
            }
          }
          approved_by_id
          approved_by {
            ... on User {
              id
              name
            }
          }
          approval_status
          approval_note
          rejection_note
          created_by_id
          created_by {
            ... on User {
              id
              name
              email
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                  name
                  object_name
                  bucket_name
                }
              }
            }
          }
          socmed_campaign_id
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;

export const GET_LIST_AD_INTEGRATION_NOTE = gql`
  query GetList($where: Map, $sort: Map) {
    GetAdIntegrationNoteList(
      pagination: { offset: 0, limit: 10, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on AdIntegrationNotes {
        data {
          id
          user_id
          user {
            ... on User {
              id
              name
              email
              active_status
              created_at
              updated_at
              deleted_at
              roles {
                ... on PaginationResponse {
                  count
                }
                ... on Roles {
                  data {
                    id
                    slug
                    created_at
                    updated_at
                    deleted_at
                  }
                }
              }
            }
          }
          ad_integration_id
          ad_integration {
            ... on AdIntegration {
              id
              ad_id
              ad {
                ... on Ad {
                  id
                  ad_set_id
                  ad_set {
                    ... on AdSet {
                      campaign_id
                      team_id
                      name
                      start_date
                      end_date
                      budget
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                  team_id
                  team {
                    ... on Team {
                      id
                      name
                      partner
                      limit
                      start_date
                      end_date
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                  name
                  start_date
                  end_date
                  budget
                  headline
                  offer
                  content
                  created_at
                  updated_at
                  deleted_at
                }
              }
              approval_status
              approval_note
              created_at
              updated_at
              deleted_at
            }
          }
          content
          created_at
        }
      }
    }
  }
`;

export const GET_AD_INTEGRATION_BY_ID = gql`
  query GetByID($id: String!) {
    list: GetAdIntegrationByID(id: $id) {
      id
      ad_id
      currency
      type
      campaign_id
      ad_set_id
      user_socmed_id
      user_socmed {
        ... on SocmedAccount {
          id
          team_id
          type
          username
          url
          account_token
          active_status
          account_id
          ad_account_id
        }
      }
      ad {
        ... on Ad {
          id
          ad_set_id
          ad_set {
            ... on AdSet {
              campaign_id
              campaign {
                ... on Campaign {
                  id
                  start_date
                  end_date
                  budget
                  brand_pic_id
                  brand_creator_id
                  agency_creator_id
                  name
                  team_id
                  agency_pic_id
                  created_at
                  updated_at
                  deleted_at
                }
              }
              id
              team_id
              name
              start_date
              end_date
              budget
              created_at
              updated_at
              deleted_at
            }
          }
          team_id
          team {
            ... on Team {
              id
              name
              partner
              limit
              start_date
              end_date
              created_at
              updated_at
              deleted_at
            }
          }
          name
          start_date
          end_date
          budget
          headline
          offer
          product_name
          promo_code
          upc_user
          sku
          discount
          discount_type
          content
          created_at
          updated_at
          deleted_at
        }
      }
      socmed_campaign_id
      socmed_ad_id
      socmed_adset_id
      approved_by_id
      approved_by {
        ... on User {
          id
          name
        }
      }
      approval_status
      approval_note
      rejection_note
      created_by_id
      created_by {
        ... on User {
          id
          name
        }
      }
      document_ids
      documents {
        ... on Document {
          id
          name
          url_link
          bucket_name
          object_name
        }
      }
      socmed_campaign_local
      socmed_ad_set_local
      socmed_ad_local
      created_at
      updated_at
      deleted_at
    }
  }
`;

export const GET_LIST_INTEGRATION_LIST_DRAFT = gql`
  query GetList($where: Map, $sort: Map) {
    GetIntegrationDraftList(
      pagination: { offset: 0, limit: 10, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on IntegrationDrafts {
        data {
          id
          team_id
          step
          data
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;

export const GET_COUNT_AD_INTEGRATION = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetAdIntegrationList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on AdIntegrations {
        data {
          id
          ad_id
        }
      }
    }
  }
`;
